import {getContext, store} from '@wordpress/interactivity';

const {state} = store('productFilter', {
    state: {
        get isHidden() {
            const context = getContext();
            if (state.filter.size === 0) {
                return false;
            }

            if (context.types) {
                for (let i = 0; i < context.types.length; i++) {
                    if (state.filter.has(context.types[i])) {
                        return false;
                    }
                }
            }
            return true;
        },
        filter: new Set(),
        changer: 0,
        get checked() {
            const context = getContext();
            const {id = 0} = context;
            return state.changer === id;
        },
        get isActive() {
            const context = getContext();
            const {id = 0} = context;
            if (!state.changer) return id === 0;
            return state.changer === id;
        }
    },
    actions: {
        handle() {
            const context = getContext();
            const {id = 0} = context;

            if (!context.checked) {
                // console.log(id);
                context.checked = true;

                if (!id || id === 0) {
                    state.filter.clear();
                } else
                    state.filter.add(id);
            } else {
                // console.log('remove');
                context.checked = false;
                state.filter.delete(id);
            }
            state.changer = id;
        }
    },
    callbacks: {
        onFilterChange() {
            const context = getContext();
            if (!state.changer) {
                context.hidden = false;
                return;
            }

            if (context.types) {
                for (let i = 0; i < context.types.length; i++) {
                    if (state.changer === parseInt(context.types[i])) {
                        context.hidden = false;
                        return;
                    }
                }
            }
            context.hidden = true;
            return true;
        }
    }
});
